var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-block"
  }, [_c('div', {
    staticClass: "left-block-text hidden",
    class: {
      show: _vm.isShow()
    }
  }, [_c('div', {
    staticClass: "left-block-text-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    staticClass: "board-name",
    attrs: {
      "src": _vm.url,
      "alt": "board-logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "board-wrapper"
  }, [_c('img', {
    staticClass: "board",
    class: {
      show: _vm.isShowContent(2)
    },
    attrs: {
      "src": require("../assets/tline.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board",
    class: {
      show: _vm.isShowContent(3)
    },
    attrs: {
      "src": require("../assets/fline.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board",
    class: {
      show: _vm.isShowContent(4)
    },
    attrs: {
      "src": require("../assets/uline.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('img', {
    staticClass: "chart",
    class: {
      show: _vm.isShowContent(2)
    },
    attrs: {
      "src": require("../assets/chartT.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "chart",
    class: {
      show: _vm.isShowContent(3)
    },
    attrs: {
      "src": require("../assets/chartF.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "chart",
    class: {
      show: _vm.isShowContent(4)
    },
    attrs: {
      "src": require("../assets/chartU.png")
    }
  })])]), _vm._v(" "), (_vm.isShowContent(2)) ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (_vm.isShowContent(3)) ? [_vm._m(1)] : _vm._e(), _vm._v(" "), (_vm.isShowContent(4)) ? [_vm._m(2)] : _vm._e()], 2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Геометрия True Twin")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Прогиб Rocker-Camber-Rocker")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("База Durasurf Sintered 4001/8.1M")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Стеклоткань Tri-Ax + Carbon")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Боковые стенки Extruded UHMW")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Сердечник Клён/Липа")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Смола "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carbon AERO")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Армирование кантов "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("KEEN System")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Геометрия Directional")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Прогиб Rocker-Camber")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("База Durasurf Sintered 4001/8.1M")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Стеклоткань Tri-Ax + Carbon")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Боковые стенки Extruded UHMW")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Сердечник Клён/Липа")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Смола "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carbon AERO")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Армирование кантов "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("KEEN System")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Геометрия Directional Twin")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Прогиб Rocker-Camber-Rocker")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("База Durasurf Sintered 4001/8.1M")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Стеклоткань Tri-Ax + Carbon")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Боковые стенки Extruded UHMW")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Сердечник Клён/Липа")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Смола "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carbon AERO")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Армирование кантов "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("KEEN System")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15db361c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftBlock.vue
// module id = QNcD
// module chunks = 0